import { observeElement, getWidget } from '@uvocore-front/utils';
import '../../theme/DefaultTheme';
import '../../components/Header/main';
import '../../components/Footer';
import template from '../../components/Testimonials/TestimonialTemplate';

observeElement({
  /* eslint-disable-line */
  element: '[data-testimonials-widget-js]',
  marginValue: 800,
  callback: () => {
    getWidget({
      /* eslint-disable-line */
      widgetLink: '/assets/js/testimonialsWidget.min.js',
      loader: false,
      fn: () => {
        window.tmWidget({
          params: {
            siteId: '14',
            limit: 9,
            maxBodyLength: 150,
          },
          callbackData: () => {
            if (document.querySelector('.Loader')) {
              document
                .querySelector('[data-testimonials-widget-js]')
                .removeChild(document.querySelector('.Loader'));
            }
          },
          template,
          type: 'html',
          moreEl: '.load-more-testimonials',
          containerEl: '[data-testimonials-widget-js]',
        });
      },
    });
  },
});
